import {makeAutoObservable} from 'mobx';
import * as Api from '@/utils/api/api';
import ShopType from 'enum/ShopType';

class ShopsStore {
    list = [];
    PAGE_SIZE = 8;
    pageSize = 8;
    pageNum = 1;
    goodsNum = 3;
    type = ShopType.All.value;
    descSort = undefined;
    servSort = undefined;
    lgstSort = undefined;
    refreshing = false;

    constructor() {
        makeAutoObservable(this)
    }

    /**
     * 获取列表
     */
    async fetchList() {
        try {
            this.refreshing = true;
            const {pageSize, pageNum, goodsNum, type, descSort, servSort} = this;

            const {list} = await Api.shopStreetList({
                pageSize,
                pageNum,
                goodsNum,
                type,
                descSort,
                servSort
            });

            this.list = list;
        } catch (error) {
        } finally {
            this.refreshing = false;
        }
    }
}

const store = new ShopsStore();

export default store;
